import { render } from "./ButtonSyncCustomerToPMS.vue?vue&type=template&id=f2095c30"
import script from "./ButtonSyncCustomerToPMS.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonSyncCustomerToPMS.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/ButtonSyncCustomerToPMS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2095c30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2095c30', __exports__)) {
    api.reload('f2095c30', __exports__)
  }
  
  module.hot.accept("./ButtonSyncCustomerToPMS.vue?vue&type=template&id=f2095c30", () => {
    api.rerender('f2095c30', render)
  })

}


export default __exports__